import { createSvgIcon } from "@mui/material/utils";
import React from "react";

const IconUserThumb = createSvgIcon(
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="white" />
    <path
      d="M21.3334 22V20.6667C21.3334 19.9594 21.0525 19.2811 20.5524 18.781C20.0523 18.281 19.374 18 18.6667 18H13.3334C12.6262 18 11.9479 18.281 11.4478 18.781C10.9477 19.2811 10.6667 19.9594 10.6667 20.6667V22"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0002 15.3333C17.4729 15.3333 18.6668 14.1394 18.6668 12.6667C18.6668 11.1939 17.4729 10 16.0002 10C14.5274 10 13.3335 11.1939 13.3335 12.6667C13.3335 14.1394 14.5274 15.3333 16.0002 15.3333Z"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "IconUserThumb",
);

export default IconUserThumb;
